/**
 * Toast Utilities
 *
 * Provides a consistent interface for displaying toast messages
 * throughout the application using react-hot-toast.
 */

import toast from 'react-hot-toast';

/**
 * Default toast options with app-specific styling
 */
const defaultOptions = {
  duration: 4000,
  position: 'top-center' as const,
  style: {
    background: '#fff',
    color: '#1f2937',
    padding: '16px',
    borderRadius: '12px',
    boxShadow:
      '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },
};

/**
 * Show a success toast notification
 */
export function showSuccessToast(message: string) {
  return toast.success(message, {
    ...defaultOptions,
    icon: '✓',
    style: {
      ...defaultOptions.style,
      border: '2px solid #14b8a6',
    },
  });
}

/**
 * Show an error toast notification
 */
export function showErrorToast(message: string) {
  return toast.error(message, {
    ...defaultOptions,
    icon: '✕',
    style: {
      ...defaultOptions.style,
      border: '2px solid #ef4444',
    },
  });
}

/**
 * Show an info toast notification
 */
export function showInfoToast(message: string) {
  return toast(message, {
    ...defaultOptions,
    icon: 'ℹ',
    style: {
      ...defaultOptions.style,
      border: '2px solid #3b82f6',
    },
  });
}

/**
 * Show a warning toast notification
 */
export function showWarningToast(message: string) {
  return toast(message, {
    ...defaultOptions,
    icon: '⚠',
    style: {
      ...defaultOptions.style,
      border: '2px solid #f59e0b',
    },
  });
}

/**
 * Dismiss all active toasts
 */
export function dismissAllToasts() {
  toast.dismiss();
}

export default toast;
